/* Davenia CRO (4 sep 2026) - abre el acordeon de Talla en las colecciones.

   El tema trae todos los acordeones de filtros cerrados (ajuste
   enable_opened_accordions, en falso). Abrirlos todos deja la columna larguisima;
   lo util es abrir solo Talla, que es el filtro que decide la compra en una
   zapateria.

   OJO con el mecanismo: no basta con poner det.open = true. El tema no usa el
   comportamiento nativo de <details>: anima el cuerpo con altura y opacidad y
   lleva el estado en aria-expanded del <summary>. Si solo se pone open, el bloque
   queda abierto en el DOM pero con height 0 y opacity 0, o sea invisible (asi
   paso en la primera version de este archivo). Por eso aqui se simula el clic en
   el summary y se deja que el JS del tema haga su trabajo.

   Se ejecuta una sola vez por carga y solo si el acordeon esta cerrado. */

(function () {
  function abrirTalla() {
    var secciones = document.querySelectorAll('details.facets__accordion-section');

    for (var i = 0; i < secciones.length; i++) {
      var det = secciones[i];
      if (!det.querySelector('input[name*="option.talla"]')) continue;

      var btn = det.querySelector('summary');
      if (!btn) continue;
      if (btn.getAttribute('aria-expanded') === 'true') continue;

      btn.click();
    }
  }

  function arranque() {
    // Un respiro para que global.js del tema haya montado los acordeones.
    setTimeout(abrirTalla, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranque);
  } else {
    arranque();
  }
})();
